export default __webpack_public_path__ + "static/media/opensea.6cf1a233.svg";